"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsx } from 'react/jsx-runtime';
import { FormulaComponentsContext } from './use-formula-components.mjs';

function FormulaComponentsProvider({
  children,
  mapping
}) {
  return /* @__PURE__ */ jsx(FormulaComponentsContext.Provider, { value: mapping, children });
}

export { FormulaComponentsProvider };
